import * as Icon from "@ant-design/icons";
import { Modal, Form, Row, Col, Flex } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table";
import { useEffect } from "react";
import { CondicaoGeralSorteioModel } from "../../models/condicaoGeralSorteio/condicaoGeralModel";
import {
  setBuscaCondicaoGeralSorteio,
  setEntityCondicaoGeralSorteio,
  setModalCadastrarCondicaoGeralSorteio,
  setModalDeletarCondicaoGeralSorteio,
} from "../../redux/slices/condicaoGeralSorteio/condicaoGeralSorteioSlice";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarCondicaoGeralSorteio, deletarCondicaoGeralSorteio } from "../../services/condicaoGeralSorteioService";
import { formatNumber, formatPercent } from "../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import CondicaoGeralSorteioModal from "./modals/cadastrar";
import { ButtonComponent } from "../../components/button/cadastrar";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";

const CondicaoGeralSorteio = () => {
  //estados globais
  const condicaoGeralSorteioState = useAppSelector((state) => state.condicaoGeralSorteio);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(condicaoGeralSorteioState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CONDIÇÕES GERAIS"));
    dispatch(buscarCondicaoGeralSorteio(condicaoGeralSorteioState.busca));
    form.setFieldsValue({ pesquisar: condicaoGeralSorteioState.busca });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityCondicaoGeralSorteio({}));
    dispatch(setModalCadastrarCondicaoGeralSorteio(true));
  };

  const goEditar = (value: CondicaoGeralSorteioModel) => {
    dispatch(setEntityCondicaoGeralSorteio(value));
    dispatch(setModalCadastrarCondicaoGeralSorteio(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarCondicaoGeralSorteio(false));
  };

  const goDeletar = (value: CondicaoGeralSorteioModel) => {
    dispatch(setEntityCondicaoGeralSorteio(value));
    dispatch(setModalDeletarCondicaoGeralSorteio(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarCondicaoGeralSorteio(false));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaCondicaoGeralSorteio(value));
    dispatch(buscarCondicaoGeralSorteio(value));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<CondicaoGeralSorteioModel> = [
    {
      title: "NÚMERO",
      dataIndex: "numeroCG",
      width: 100,
      align: "right",
      sorter: (a, b) => a.numeroCG - b.numeroCG,
      sortDirections: ["ascend", "descend", "ascend"],
    },

    {
      title: "PROCESSO",
      dataIndex: "numeroProcesso",
      align: "right",
      sorter: (a, b) => a.numeroProcesso.localeCompare(b.numeroProcesso),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "TAMANHO DA SÉRIE",
      dataIndex: "tamanhoSerie",
      align: "right",
      sorter: (a, b) => a.tamanhoSerie - b.tamanhoSerie,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => formatNumber(record.tamanhoSerie),
    },
    {
      title: "QUOTA SORTEIO",
      dataIndex: "quotaSorteio",
      align: "right",
      render: (_, record) => formatPercent(record.quotaSorteio),
    },
    {
      title: "QUOTA RESGATE",
      dataIndex: "quotaResgate",
      align: "right",
      render: (_, record) => formatPercent(record.quotaResgate),
    },
    {
      title: "QUOTA CARREGAMENTO",
      dataIndex: "quotaCarregamento",
      align: "right",
      render: (_, record) => formatPercent(record.quotaCarregamento),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Número ou Processo" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={condicaoGeralSorteioState.list} columns={columns} loading={condicaoGeralSorteioState.loading} />
      <Modal
        title={editar ? "EDITAR CONDIÇÃO GERAL" : "NOVA CONDIÇÃO GERAL"}
        centered
        width={900}
        open={condicaoGeralSorteioState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CondicaoGeralSorteioModal />
      </Modal>
      <Modal title={"REMOVER CONDIÇÃO GERAL"} centered width={350} open={condicaoGeralSorteioState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover a condição geral?"
          action={deletarCondicaoGeralSorteio({ value: condicaoGeralSorteioState.entity.id, busca: condicaoGeralSorteioState.busca })}
          close={setModalDeletarCondicaoGeralSorteio(false)}
        />
      </Modal>
    </Flex>
  );
};

export default CondicaoGeralSorteio;
